export default function initializeCalculator() {
    initializeEvents();
}

function initializeEvents() {
    let internetSelect = $('#calc-internet');
    let tvSelect = $('#calc-tv');

    internetSelect.on('change', function () {
        priceCalculation();
    });

    tvSelect.on('change', function () {
        priceCalculation();
        showChannels();
    });

    $('.calculator__checkbox').each(function () {
        $(this).on('change', function () {
            priceCalculation();
            showChannels();
        })
    });
}

function showChannels() {
    let checkboxes = $('.calculator__checkbox');
    let tvSelect = $('#calc-tv')
    let titleContainer = $('.calculator__packages-title');

    let selectOptions = tvSelect.find('option'),
        showTitle = false;

    selectOptions.each(function () {
        if ($(this) !== 'none') {
            $('.channel-group-' + $(this).val()).removeClass('calculator__channels-group--visible');
        }
    });

    titleContainer.removeClass('calculator__packages-title--visible');

    if (tvSelect.val() !== 'none') {
        let val = tvSelect.find('option:selected').val();

        $('.channel-group-' + val).addClass('calculator__channels-group--visible');
        showTitle = true;
    }

    checkboxes.each(function () {
        let channelGroup = $('.channel-group-' + $(this).data('id'));

        if ($(this).is(':checked')) {
            channelGroup.addClass('calculator__channels-group--visible');

            if (channelGroup.length > 0) {
                showTitle = true;
            }
        } else {
            channelGroup.removeClass('calculator__channels-group--visible');
        }
    });

    if (showTitle) {
        titleContainer.addClass('calculator__packages-title--visible');
    }
}

function priceCalculation() {
    let priceInput = $('#calc-price');
    let internetSelect = $('#calc-internet');
    let tvSelect = $('#calc-tv');
    let checkboxes = $('.calculator__checkbox');
    let price = 0;

    if (internetSelect.val() === 'none') {
        if (tvSelect.val() !== 'none') {
            price += parseFloat(tvSelect.find('option:selected').data('price'));
        }
    } else {
        if (tvSelect.val() === 'none') {
            price += parseFloat(internetSelect.find('option:selected').data('price'));
        } else {
            price += parseFloat(internetSelect.find('option:selected').data('price-' + tvSelect.val()));
        }
    }

    checkboxes.each(function () {
        if ($(this).is(':checked')) {
            price += parseFloat($(this).data('price'));
        }
    });

    priceInput.val(price.toFixed(2).toString().replace('.', ',') + ' zł');
}